import axios from "../utils/axios";


// Rating APIs
export const submitRating = (data) => axios.post("/api/ratings", data);

export const getRatings = (params) => axios.get("/api/ratings", { params });

export const getRatingById = (id) => axios.get(`/api/ratings/${id}`);

export const updateRating = (id, data) => axios.put(`/api/ratings/${id}`, data);

export const deleteRating = (id) => axios.delete(`/api/ratings/${id}`);
